// Generated by CoffeeScript 2.7.0
var UserBoundary, adminUrlFor;

import Ajax from 'libs/ajax.js';

import UrlHelper from 'helpers/url_helper.js';

import BaseModel from './base_model.js';

({adminUrlFor} = UrlHelper);

export default UserBoundary = (function() {
  class UserBoundary extends BaseModel {
    constructor(attrs = {}) {
      super(attrs);
      this.overlord = attrs.overlord;
      this.ccVertices = attrs.cc_vertices;
      this.reviewerVertices = attrs.reviewer_vertices;
    }

    calculteCount() {
      if (_.isEmpty(this.user_ids) && _.isEmpty(data.organization_ids)) {
        this.users_count = 0;
        return this.organizations_count = 0;
      } else {
        return Ajax.get(adminUrlFor('/user_boundaries/count'), {
          data: {
            user_boundary: this.toJSON()
          },
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: (data, xhr) => {
            this.users_count = data.users_count;
            return this.organizations_count = data.organizations_count;
          }
        });
      }
    }

    update(ub) {
      return _.extend(this, _.pick(ub, 'user_ids', 'users', 'user_tags', 'user_tag_ids', 'user_tagged_type', 'organizations', 'organization_ids', 'only_binded'));
    }

    isEmpty() {
      return _.isEmpty(this.user_ids) && _.isEmpty(this.organization_ids) && _.isEmpty(this.ccVertices) && _.isEmpty(this.reviewerVertices);
    }

    toJSON() {
      var ub;
      ub = super.toJSON();
      return _.omit(ub, 'users', 'organizations', 'user_tags', 'users_count', 'organizations_count');
    }

  };

  UserBoundary.setAttributes([
    {
      user_ids: [],
      users: [],
      user_tags: [],
      user_tag_ids: [],
      organization_ids: [],
      organizations: [],
      only_binded: false,
      user_tagged_type: 'intersection',
      users_count: 0,
      organizations_count: 0,
      cc_vertex_ids: [],
      reviewer_vertex_ids: []
    }
  ]);

  return UserBoundary;

}).call(this);
